import {MediaMatcher} from '@angular/cdk/layout';
import {Location} from '@angular/common';
import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import {MatSort} from '@angular/material/sort';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {ActivatedRoute, NavigationStart, Params, Router} from '@angular/router';
import {firstValueFrom, Subject} from 'rxjs';
import {filter, take, takeUntil} from 'rxjs/operators';
import {AventiObject} from 'src/app/models/AventiObject';
import {JOB_STATUS, JobFrontendState, JobGroup, RtJobGroup, RtJobState} from 'src/app/models/Job';
import {Checklist} from 'src/app/models/Checklist';
import {ChecklistItem} from 'src/app/models/Checklistitem';
import {AventiFile} from 'src/app/models/File';
import {User} from 'src/app/models/User';
import {ChecklistService} from 'src/app/services/checklist.service';
import {DateService} from 'src/app/services/date.service';
import {IdService} from 'src/app/services/id.service';
import {SharedService} from 'src/app/services/shared.service';
import {environment} from 'src/environments/environment';
import {ObjectchecklistsComponent} from '../../checklists/objectchecklists/objectchecklists.component';
import {CanDeactivateComponent} from '../../common/can-deactivate/can-deactivate.component';
import {NewObjectComponent} from '../new-object/new-object.component';
import {NewObjectsMultipleComponent} from '../new-objects-multiple/new-objects-multiple.component';
import {ExcelService} from 'src/app/services/excel.service';
import {Table} from 'primeng/table';
import {FilterMetadata, SortMeta} from 'primeng/api';
import {SortButton} from 'src/app/models/PrimeNG';
import {TableService} from 'src/app/services/prime/table.service';
import {AdminService} from 'src/app/services/admin.service';
import * as _ from 'underscore';
import {ObjectStatus} from 'src/app/models/Status';
import {Project} from 'src/app/models/Project';
import {ObjectService} from 'src/app/services/object.service';
import {ConfirmComponent} from '../../common/bottom-sheet/confirm/confirm.component';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {SnackbarService} from 'src/app/services/snackbar.service';
import {JobService} from 'src/app/services/job.service';

@Component({
  selector: 'app-object-list',
  templateUrl: './object-list.component.html',
  styleUrls: ['./object-list.component.css'],
})

export class ObjectListComponent
  extends CanDeactivateComponent
  implements OnInit, OnDestroy, AfterViewInit {
  disableRoute = false;
  isImportingObjects = false;
  objects: AventiObject[];
  objectsAll: AventiObject[];
  objectsFrontend: AventiObject[];
  objectsTemp: AventiObject[];
  checklists: Checklist[];
  checklistitems: ChecklistItem[];
  checklistfiles: AventiFile[];
  checklistpdfs: AventiFile[];
  archivedVisible = false;
  numberOfArchived = 0;
  objectsReady: boolean;
  isEmpty = false;
  projectid: string;
  user: User;
  isLoading = true;
  isOnline: boolean;
  isGeneratingPDF = false;

  dataSource: MatTableDataSource<AventiObject>; // = new MatTableDataSource();
  pageIndex = 0;
  pageSize = 25;
  params: Params;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  mobileQuery: MediaQueryList;
  filter = '';
  sortactive = '';
  sortdirection: 'asc' | 'desc';
  FormFilter = new UntypedFormGroup({
    filter: new UntypedFormControl('', []),
  });
  selectedRows: AventiObject[] = [];
  tableFiltersReady = false;
  pauseSorting = false;
  resetTable = false;
  numberOfTableSorts = 0;
  numberOfTableFilters = 0;
  tableSort: SortMeta[];
  tableFilters: { [p: string]: FilterMetadata } = {};
  sortButtons: SortButton[] = [
    {name: 'Objekt', sort: {field: 'nameSearchString', order: 0}},
    {name: 'TFM/RDS', sort: {field: 'tfmRdsSearchString', order: 0}},
    {name: 'Prosess', sort: {field: 'process', order: 0}},
    {name: 'Type', sort: {field: 'typename', order: 0}},
    {name: 'Profilnummer', sort: {field: 'profilenumber', order: 0}},
    {name: 'Tags', sort: {field: 'tagsSearchString', order: 0}},
    {name: 'Sjekkliste', sort: {field: 'checklistPresent', order: 0}}
  ];
  filterFields: string[] = [];
  displayedColumns: string[] = [];
  searchString = '';
  statuses: ObjectStatus[] = [];
  statusNames: string[] = [];
  statusCount: any[] = [];
  // Synthetic object statuses (not stored ObjectStatus docs) for objects that have
  // not reached any real status level yet, so they are filterable in the list.
  private readonly STARTED_STATUS = {name: 'Påbegynt', enName: 'Started'};
  private readonly NOT_STARTED_STATUS = {name: 'Ikke startet', enName: 'Not started'};
  private readonly MISSING_CHECKLIST_STATUS = {name: 'Mangler sjekkliste', enName: 'Missing checklist'};
  processes: any[] = [];
  descs: any[] = [];
  drawings: any[] = [];
  comments: any[] = [];
  types: any[] = [];
  profilenumbers: any[] = [];
  isAdmin: boolean;
  isSuperAdmin: boolean;
  project: Project;
  jobFrontendState: JobFrontendState;
  jobFrontendStateTotalCount: number;
  @ViewChild('dataTable') dt: Table;
  protected readonly JOB_STATUS = JOB_STATUS;
  private ngUnsubscribe = new Subject();
  private ngUnsubscribeChecklists = new Subject();
  private ngUnsubscribeChecklistPdfs = new Subject();
  private ngUnsubscribeObjectsShared = new Subject();
  private ngUnsubscribeChecklistsShared = new Subject();
  private ngUnsubscribeChecklistPdfsShared = new Subject();

  constructor(
    private idservice: IdService,
    media: MediaMatcher,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sharedservice: SharedService,
    private checklistservice: ChecklistService,
    private objectservice: ObjectService,
    private dateservice: DateService,
    private dialogObjectChecklists: MatDialog,
    private location: Location,
    private dialogNewObject: MatDialog,
    private excelservice: ExcelService,
    private dialog: MatDialog,
    private ptableService: TableService,
    private adminservice: AdminService,
    private bottomSheet: MatBottomSheet,
    private snackbarservice: SnackbarService,
    private jobservice: JobService
  ) {
    super();
    this.projectid = this.idservice.projectId();
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
    this.adminservice
      .getObjectStatuses()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (statuses) => {
        this.statuses = _.reject(statuses, _.isNull);
        this.statuses = _.sortBy(this.statuses, 'priority');
        const en = this.user.language?.id === 'en';
        this.statusNames = this.statuses.map(status => en ? status.enName : status.name);
        this.statusNames.push(
          en ? this.STARTED_STATUS.enName : this.STARTED_STATUS.name,
          en ? this.NOT_STARTED_STATUS.enName : this.NOT_STARTED_STATUS.name,
          en ? this.MISSING_CHECKLIST_STATUS.enName : this.MISSING_CHECKLIST_STATUS.name
        );
        this.isLoading = false;
        if (statuses !== null) {
          await this.buildObjects();
        }
      });
  }

  get desc() {
    return this.FormFilter.get('filter');
  }

  canDeactivate(): boolean {
    return !this.isGeneratingPDF;
  }

  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.data = this.objects;
    }
    // tslint:disable-next-line:only-arrow-functions
    this.dt.resetScrollTop = function() {
    };
  }

  async ngOnInit(): Promise<void> {
    this.isOnline = await firstValueFrom(this.sharedservice.online);

    this.jobservice.rtDbGetJobStatesForProject(this.projectid)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (rtJob) => {
        if (rtJob !== null) {
          if (rtJob.length === 0) {
            this.jobFrontendState = {
              status: JOB_STATUS.COMPLETED,
              progress: 0,
              totalCount: 0
            };
            this.jobFrontendStateTotalCount = 0;
            setTimeout(async () => {
              if (this.isImportingObjects) {
                this.isImportingObjects = false;
                this.sharedservice.isImportingObjects.next(this.isImportingObjects);
              }
            }, 1000);
            return;
          } else {
            const jobGroup = rtJob.find(rtJobState => (rtJobState as JobGroup).totalCount) as RtJobGroup;
            const rtJobStates = rtJob.filter(rtJobState => !(rtJobState as JobGroup).totalCount) as RtJobState[];
            const isQueued = rtJobStates.every(state => state.status === JOB_STATUS.QUEUED);
            const isSavingFirestore = rtJobStates.every(state => state.status === JOB_STATUS.SAVING_FIRESTORE);
            const isSavingRtDb = rtJobStates.every(state => state.status === JOB_STATUS.SAVING_RTDB);
            const isComplete = rtJobStates.every(state => state.status === JOB_STATUS.COMPLETED);
            const isFailed = rtJobStates.some(state => state.status === JOB_STATUS.FAILED);
            const progress = Math.round(rtJobStates.map(rtJobState => rtJobState.progress)
              .reduce((acc, progress) => acc + progress, 0) / rtJobStates.length);

            if (!this.isImportingObjects) {
              this.isImportingObjects = true;
              this.sharedservice.isImportingObjects.next(this.isImportingObjects);
            }

            const jobFrontendState: JobFrontendState = {
              status:
                isFailed ? JOB_STATUS.FAILED
                  : (isComplete ? JOB_STATUS.COMPLETED
                      : (isQueued ? JOB_STATUS.QUEUED
                          : (isSavingRtDb ? JOB_STATUS.SAVING_RTDB
                              : (isSavingFirestore ? JOB_STATUS.SAVING_FIRESTORE
                                  : JOB_STATUS.IN_PROGRESS
                              )
                          )
                      )
                  ),
              progress,
              totalCount: jobGroup?.totalCount || 0,
            };
            this.jobFrontendStateTotalCount = jobFrontendState.totalCount;
            this.jobFrontendState = jobFrontendState;

            if (jobFrontendState.status === JOB_STATUS.COMPLETED) {
              this.snackbarservice.openSnackBar(
                this.user.language?.id === 'en' ? `${jobFrontendState.totalCount} objects imported successfully.` : `${jobFrontendState.totalCount} objekter importert.`,
                'OK'
              );
              console.log('Job completed:', jobFrontendState);
              if (this.isImportingObjects) {
                console.log('Fetching objects after import...');
                this.isImportingObjects = false;
                this.sharedservice.isImportingObjects.next(this.isImportingObjects);
              } else {
                console.log('Not importing objects, skipping fetch.');
              }
            } else if (isFailed) {
              if (this.isImportingObjects) {
                this.isImportingObjects = false;
                this.sharedservice.isImportingObjects.next(this.isImportingObjects);
                this.snackbarservice.openSnackBar(
                  this.user.language?.id === 'en' ? 'Some objects failed to import.' : 'Noen objekter ble ikke importert.',
                  'OK'
                );
              }
            }
          }

        }
      });

    this.sharedservice.project
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((project) => {
        if (project !== null) {
          this.project = project;
        }
      });

    this.sharedservice.user
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((user) => {
        if (user != null) {
          this.isAdmin = user.role?.name === 'admin';
          this.isSuperAdmin = user.superAdmin;
        }
      });

    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationStart),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(async () => {
        if (!this.resetTable && !this.tableFiltersReady) {
          await this.callSetTableSortAndFilterFromQueryParams();
        }
      });

    this.objects = null;
    this.checklists = null;
    this.checklistpdfs = null;
    this.objectsReady = false;

    this.sharedservice.user
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((user) => {
        if (user != null) {
          this.user = user;
        }
      });

    this.sharedservice.objects
      .pipe(takeUntil(this.ngUnsubscribeObjectsShared))
      .subscribe(async (objects: AventiObject[]) => {
        this.objectsTemp = objects;
        if (objects !== null) {
          if (!this.isImportingObjects) {
            await this.buildObjects();
          }
        }
      });

  }

  newObject() {
    this.dialogNewObject.open(NewObjectComponent, {
      backdropClass: 'blur-dialog-backdrop',
      width: '560px',
      maxWidth: '95vw',
    });
  }

  downloadTemplateForMultipleObjects() {
    this.excelservice.exportAsExcelFile(
      [
        {
          name: '',
          tfmTag: '',
          rdsTag: '',
          process: '',
          type: '',
          desc: '',
          profilenumber: '',
          drawing: '',
          comment: '',
        },
      ],
      'importmal'
    );
  }

  async downloadObjectsToExcel() {
    const filtered: AventiObject[] = this.dt?.filteredValue;
    // Each option carries the rows it exports, so the dismiss handler needs no lookup.
    const options = [];
    if (this.selectedRows.length > 0) {
      options.push({
        name: 'Valgte objekter',
        icon: 'checklist',
        value: this.selectedRows,
        count: this.selectedRows.length,
      });
    }
    if (filtered) {
      options.push({
        name: 'Filtrerte objekter',
        icon: 'filter_alt',
        value: filtered,
        count: filtered.length,
      });
    }
    if (options.length === 0) {
      await this.exportObjectsToExcel(this.objectsAll);
      return;
    }
    options.push({
      name: 'Alle objekter i prosjektet',
      icon: 'select_all',
      value: this.objectsAll,
      count: this.objectsAll.length,
    });

    const sheet = this.bottomSheet.open(ConfirmComponent, {
      backdropClass: 'blur-dialog-backdrop',
      data: {
        title: 'Eksporter objekter til Excel',
        text: 'Hvilke objekter vil du eksportere?',
        options,
        no: {
          name: 'Avbryt',
          icon: 'close',
        },
      },
    });

    sheet
      .afterDismissed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (rows) => {
        if (Array.isArray(rows)) {
          await this.exportObjectsToExcel(rows);
        }
      });
  }

  private async exportObjectsToExcel(objects: AventiObject[]) {
    const objectsForExport = [];
    const allObjects = structuredClone(objects);
    const f = await firstValueFrom(this.checklistservice.getAllChecklistFiles());
    allObjects.forEach((object) => {
      object.checklists?.forEach((checklist) => {
        f.forEach((file) => {
          if (
            file.checklistid === checklist.id &&
            (!file.checklistitemid || file.checklistitemid === '')
          ) {
            if (!checklist.files) {
              checklist.files = [];
            }
            checklist.files.push(file);
          }
        });
      });
    });
    allObjects.forEach((object) => {
      const checklistIds = [];
      const checklistStatus = [];
      const checklistPdfids = [];
      const checklistPdfs = [];
      const checklistImageIds = [];
      const checklistImages = [];
      const checklistImageLat = [];
      const checklistImageLng = [];
      object.checklists?.forEach((checklist) => {
        checklistIds.push(checklist.id);
        checklistStatus.push(checklist.status);
        checklist.pdfexports?.forEach((pdf) => {
          checklistPdfids.push(pdf.id);
          checklistPdfs.push(pdf.downloadurl);
        });
        checklist.files?.forEach((file) => {
          checklistImageIds.push(file.id);
          checklistImages.push(file.downloadurl);
          checklistImageLat.push(file.exif?.latitude || 'null');
          checklistImageLng.push(file.exif?.longitude || 'null');
        });
      });
      objectsForExport.push({
        objectid: object.id,
        name: object.name,
        tfmTag: object.tfmTag,
        rdsTag: object.rdsTag,
        process: object.process,
        type: object.type?.name,
        desc: object.desc,
        profilenumber: object.profilenumber,
        drawing: object.drawing,
        comment: object.comment,
        checklist_ids: checklistIds.join(),
        checklist_count: checklistIds.length,
        checklist_status: checklistStatus.join(),
        checklist_pdfids: checklistPdfids.join(),
        checklist_pdf_count: checklistPdfids.length,
        checklist_pdfs: checklistPdfs.join(),
        checklist_image_ids: checklistImageIds.join(),
        checklist_image_count: checklistImageIds.length,
        checklist_images: checklistImages.join(),
        checklist_image_lat: checklistImageLat.join(),
        checklist_image_lng: checklistImageLng.join(),
      });
    });
    this.excelservice.exportAsExcelFile(objectsForExport, 'objects');
  }

  downloadObjectUrlsToExcel() {
    const objectsForExport = [];
    const baseUrl = environment.baseURL;
    this.sharedservice.objects.pipe(take(1)).subscribe((o: AventiObject[]) => {
      console.log(o);
      o.forEach((object) => {
        objectsForExport.push({
          name: object.name,
          tfmTag: object.tfmTag,
          rdsTag: object.rdsTag,
          desc: object.desc,
          profilenumber: object.profilenumber,
          url: baseUrl +
            'p/' +
            object.projectid +
            '/o/' +
            object.id
        });
      });
      console.log(objectsForExport);
      this.excelservice.exportAsExcelFile(objectsForExport, 'objecturls');
    });
  }

  uploadMultipleObjects() {
    document.getElementById('objectimportinput').click();
  }

  async dataFromExcelEventEmitter(data) {
    const dialogRef = this.dialog.open(NewObjectsMultipleComponent, {
      closeOnNavigation: true,
      disableClose: false,
      width: '100%',
      backdropClass: 'blur-dialog-backdrop',
    });
    dialogRef.componentInstance.data = data;
    dialogRef.afterClosed().subscribe(async () => {
      await this.buildObjects();
    });
  }

  async buildObjects() {
    if (
      this.objectsTemp &&
      this.statuses
    ) {

      if (this.objectsTemp.length === 0) {
        this.isEmpty = true;
        this.displayedColumns = [];
      } else {
        this.isEmpty = false;
        this.setDisplayedColumns(this.mobileQuery.matches);
      }
      this.numberOfArchived = 0;
      this.objects = [];
      this.objectsAll = [];
      this.objectsTemp.forEach((object) => {
        object.typename = object.type?.name;
        object.nameSearchString = object.name;
        object.tfmRdsSearchString = object.tfmTag + object.rdsTag;
        const enLang = this.user.language?.id === 'en';
        if (object.status?.name) {
          object.statusSearchString = enLang ? object.status.enName : object.status.name;
        } else if (object.checklists && object.checklists.length > 0) {
          const synthetic = this.objectChecklistStarted(object) ? this.STARTED_STATUS : this.NOT_STARTED_STATUS;
          object.statusSearchString = enLang ? synthetic.enName : synthetic.name;
        } else {
          object.statusSearchString = enLang ? this.MISSING_CHECKLIST_STATUS.enName : this.MISSING_CHECKLIST_STATUS.name;
        }
        let tagsSearchString = '';
        object.tags?.map(tag => {
          tagsSearchString += tag.key + tag.value;
        });
        object.tagsSearchString = tagsSearchString;

        const newProcess = {
          label: object.process,
          value: object.process
        };
        if (object.process?.length > 0 &&
          !this.processes.some(item => item.label === object.process || item.value === object.process)) {
          this.processes.push(newProcess);
        }

        const newDesc = {
          label: object.desc,
          value: object.desc
        };
        if (object.desc?.length > 0 &&
          !this.descs.some(item => item.label === object.desc || item.value === object.desc)) {
          this.descs.push(newDesc);
        }

        const newDrawing = {
          label: object.drawing,
          value: object.drawing
        };
        if (object.drawing?.length > 0 &&
          !this.drawings.some(item => item.label === object.drawing || item.value === object.drawing)) {
          this.drawings.push(newDrawing);
        }

        const newComment = {
          label: object.comment,
          value: object.comment
        };
        if (object.comment?.length > 0 &&
          !this.comments.some(item => item.label === object.comment || item.value === object.comment)) {
          this.comments.push(newComment);
        }

        const newType = {
          label: object.type?.name,
          value: object.type?.name
        };
        if (object.type?.name?.length > 0 &&
          !this.types.some(item => item.label === object.type.name || item.value === object.type.name)) {
          this.types.push(newType);
        }

        const newProfileNumber = {
          label: object.profilenumber,
          value: object.profilenumber
        };
        if (object.profilenumber?.length > 0 &&
          !this.profilenumbers.some(item => item.label === object.profilenumber || item.value === object.profilenumber)) {
          this.profilenumbers.push(newProfileNumber);
        }

        object.checklistPresent = (object.checklists && object.checklists.length > 0);

        if (!object.isarchived) {
          this.objects.push(object);
        } else {
          this.numberOfArchived++;
          if (this.archivedVisible) {
            this.objects.push(object);
          }
        }
        this.objectsAll.push(object);
      });
      this.descs.sort((a, b) => a.label.localeCompare(b.label));
      this.drawings.sort((a, b) => a.label.localeCompare(b.label));
      this.comments.sort((a, b) => a.label.localeCompare(b.label));
      this.processes.sort((a, b) => a.label.localeCompare(b.label));
      this.types.sort((a, b) => a.label.localeCompare(b.label));
      this.profilenumbers.sort((a, b) => a.label.localeCompare(b.label));

      if (!this.objectsFrontend) {
        this.objectsFrontend = structuredClone(this.objectsTemp);
      } else {
        // First, update or add
        this.objectsTemp.forEach(newObj => {
          const existing = this.objectsFrontend?.find(o => o.id === newObj.id);
          if (existing) {
            Object.assign(existing, newObj);
          } else {
            this.objectsFrontend.push(newObj);
          }
        });

        // Remove stale (not in objectsTemp) — IN-PLACE
        for (let i = this.objectsFrontend.length - 1; i >= 0; i--) {
          const id = this.objectsFrontend[i].id;
          if (!this.objectsTemp.some(o => o.id === id)) {
            this.objectsFrontend.splice(i, 1);
          }
        }
        this.objectsFrontend = [...this.objectsFrontend];
      }
      if (!this.dataSource) {
        await this.fillDataSource(this.objectsTemp);
      }
      this.dataSource.data = [...this.objectsFrontend];
    }
    this.statusCount = [];
    this.statuses.forEach(status => {
      this.statusCount.push({
        ...status,
        count: this.objectsTemp ? this.objectsTemp.filter(o => o.status?.name === status.name).length : 0
      });
    });
    this.pushSyntheticStatusCounts(this.objectsTemp ?? []);
  }

  // True when the object has no completed status level but a checklist that is under way.
  objectChecklistStarted(object: AventiObject): boolean {
    return !!object.checklists?.some(cl => cl.status && cl.status !== 'not_started');
  }

  // Append the 'Påbegynt' / 'Ikke startet' / 'Mangler sjekkliste' filter chips, counted over the given scope.
  private pushSyntheticStatusCounts(scoped: AventiObject[]) {
    const noStatusWithChecklist = scoped.filter(o => !o.status?.name && o.checklists?.length > 0);
    const started = noStatusWithChecklist.filter(o => this.objectChecklistStarted(o)).length;
    const notStarted = noStatusWithChecklist.filter(o => !this.objectChecklistStarted(o)).length;
    const missing = scoped.filter(o => !o.status?.name && !(o.checklists?.length > 0)).length;
    this.statusCount.push({...this.STARTED_STATUS, count: started});
    this.statusCount.push({...this.NOT_STARTED_STATUS, count: notStarted});
    this.statusCount.push({...this.MISSING_CHECKLIST_STATUS, count: missing});
  }

  async fillDataSource(objects: AventiObject[]) {
    if (!this.dataSource) {
      this.dataSource = new MatTableDataSource(objects);
    }
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = (
      data,
      filterInput: string
    ): boolean => {
      const filterLowerCase = filterInput.toLowerCase();
      return (
        data.id.toLowerCase().includes(filterLowerCase) ||
        data.name.toLowerCase().includes(filterLowerCase) ||
        data.type?.name?.toLowerCase().includes(filterLowerCase) ||
        data.profilenumber?.toString()?.toLowerCase().includes(filterLowerCase) ||
        data.process?.toString()?.toLowerCase().includes(filterLowerCase) ||
        data.desc?.toLowerCase().includes(filterLowerCase) ||
        data.lastupdatedString?.toString().includes(filterLowerCase) ||
        (data.tags && JSON.stringify(data.tags).toLowerCase().includes(filterLowerCase))
      );
    };

    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
      case 'lastupdated': {
        if (item.lastupdated) {
          return this.dateservice.dateAsYYYYMMDDHHNNSS(item.lastupdated);
        } else {
          return null;
        }
      }
      case 'type': {
        if (item.type) {
          return item.type.name;
        } else {
          return null;
        }
      }
      case 'mobile': {
        let searchstring = '';
        if (item.type.name) {
          searchstring += item.type.name;
        }
        if (item.name) {
          searchstring += item.name;
        }
        if (item.profilenumber) {
          searchstring += item.profilenumber;
        }
        return searchstring;
      }
      case 'checklists': {
        if (item.checklists && item.checklists.length > 0) {
          return item.checklists[0].status;
        } else {
          return null;
        }
      }
      case 'checklistpdfs': {
        if (item.checklists && item.checklists.length > 0) {
          if (
            item.checklists[0].pdfexports &&
            item.checklists[0].pdfexports.length > 0
          ) {
            return 'pdf' + item.checklists[0].pdfexports[0].name;
          } else {
            return item.checklists[0].status;
          }
        } else {
          return 'zzzzzzzzzz';
        }
      }
      case 'deliveredToCustomer': {
        if (item.checklists && item.checklists.length > 0) {
          if (
            item.checklists[0].PDFDeliveredToCustomer &&
            item.checklists[0].PDFDeliveredToCustomer.status
          ) {
            return 3;
          } else if (item.checklists[0].status === 'signed') {
            return 2;
          } else {
            return 1;
          }
        } else {
          return 0;
        }
      }
      default:
        return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    this.objectsReady = true;

    const dataLength = objects?.length;
    if (dataLength === 0) {
      this.isEmpty = true;
      this.displayedColumns = [];
    } else {
      this.isEmpty = false;
      this.setDisplayedColumns(this.mobileQuery.matches);
    }
    this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
      this.sortactive = params.sortactive;
      this.sortdirection = params.sortdirection;
      if (!this.sortactive?.includes('checklists')) {
        this.setSortingOnLoad();
      }
    });
    this.isLoading = false;
    await this.callSetTableSortAndFilterFromQueryParams();
    this.getFilterOnLoad();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
    this.ngUnsubscribeChecklists.next(null);
    this.ngUnsubscribeChecklists.complete();
    this.ngUnsubscribeChecklistPdfs.next(null);
    this.ngUnsubscribeChecklistPdfs.complete();
    this.ngUnsubscribeObjectsShared.next(null);
    this.ngUnsubscribeObjectsShared.complete();
    this.ngUnsubscribeChecklistsShared.next(null);
    this.ngUnsubscribeChecklistsShared.complete();
    this.ngUnsubscribeChecklistPdfsShared.next(null);
    this.ngUnsubscribeChecklistPdfsShared.complete();
  }

  setSortingOnLoad() {
    this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
      this.sortactive = params.sortactive;
      this.sortdirection = params.sortdirection;
      if (
        this.sortactive?.length > 0 &&
        this.sort?.active !== this.sortactive &&
        this.sort?.direction !== this.sortdirection
      ) {
        this.sort.sort({
          id: this.sortactive,
          start: this.sortdirection,
          disableClear: false,
        });
      }
    });
  }

  getFilterOnLoad() {
    this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
      this.filter = params.filter;
      // document.getElementById('filter').nodeValue = filter;
      this.FormFilter.patchValue({
        filter: this.filter,
      });
      if (this.filter && this.filter?.length > 0) {
        // this.applyFilter(null, this.filter);
      }
    });
  }


  setDisplayedColumns(matches) {
    if (matches) {
      this.displayedColumns = [
        'mobile',
        'checklists',
      ];
    } else {
      this.displayedColumns = [
        'process',
        'type',
        'name',
        'desc',
        'profilenumber',
        'tags',
        'comment',
        'checklists',
        'lastupdated',
      ];
    }
    this.filterFields = this.displayedColumns;
    this.filterFields.push('nameSearchString', 'checklistPresent', 'typename', 'statusSearchString');
  }

  openDialogObjectChecklists(object: AventiObject) {
    this.toggleDisableRoute();
    const path = this.location.path();
    const dialogRef: MatDialogRef<ObjectchecklistsComponent> =
      this.dialogObjectChecklists.open(ObjectchecklistsComponent, {
        closeOnNavigation: true,
        disableClose: false,
        width: '100%',
        backdropClass: 'blur-dialog-backdrop',
      });
    dialogRef.afterOpened().subscribe(() => {
      this.location.replaceState(path);
    });
    dialogRef.componentInstance.object = object;
    dialogRef.componentInstance.popup = true;
  }

  toggleDisableRoute() {
    this.disableRoute = true;
    setTimeout(() => this.disableRoute = false, 100);
  }

  async onSort(event) {
    if (this.tableFiltersReady && !this.pauseSorting && !this.resetTable) {
      const sortArray: SortMeta[] = event.multisortmeta;
      this.tableSort = sortArray;
      this.sortButtons =
        await this.ptableService.onSort(sortArray, this.sortButtons, this.tableSort, this.tableFilters, this.tableFiltersReady);
    }
  }

  async sortFromButton(button: SortButton) {
    this.pauseSorting = true;
    const {
      tableSort,
      numberOfTableSorts,
      sortButtons
    } = await this.ptableService.sortFromButton(
      button,
      this.sortButtons,
      this.tableSort,
      this.tableFilters,
      this.tableFiltersReady,
      this.numberOfTableSorts
    );
    this.tableSort = tableSort;
    this.numberOfTableSorts = numberOfTableSorts;
    this.sortButtons = sortButtons;
    this.pauseSorting = false;
  }

  async clearTable(table: Table) {
    this.resetTable = true;
    this.searchString = '';
    this.selectedRows = [];
    const {
      tableSort,
      numberOfTableFilters,
      numberOfTableSorts,
      sortButtons
    } = await this.ptableService.clearTable(table, this.tableSort, this.sortButtons);
    this.tableSort = tableSort;
    this.numberOfTableFilters = numberOfTableFilters;
    this.numberOfTableSorts = numberOfTableSorts;
    this.sortButtons = sortButtons;
    this.resetTable = false;
  }

  async resetTableSort() {
    const {
      tableSort,
      sortButtons,
      tableFilters,
      numberOfTableFilters,
      numberOfTableSorts,
      searchString
    } = await this.ptableService.resetTableSort(
      this.tableSort,
      this.sortButtons,
      this.tableFilters,
      this.tableFiltersReady,
      this.tableFilters
    );
    this.tableSort = tableSort;
    this.sortButtons = sortButtons;
    this.tableFilters = tableFilters;
    this.numberOfTableFilters = numberOfTableFilters;
    this.numberOfTableSorts = numberOfTableSorts;
    this.searchString = searchString;
  }

  async onFilter(event: any) {
    if (this.tableFiltersReady && !this.resetTable) {
      const eventFilters: { [p: string]: FilterMetadata } = event.filters;
      this.numberOfTableFilters = await this.ptableService.setQueryParamsFromTableEvents(
        this.tableSort,
        this.tableFiltersReady,
        eventFilters
      );
      this.statusCount = [];
      this.statuses.forEach(status => {
        this.statusCount.push({
          ...status,
          count: this.objectsTemp.filter(o => o.status?.name === status.name && event.filteredValue.some(v => v.id === o.id)).length
        });
      });
      const scoped = this.objectsTemp.filter(o => event.filteredValue.some(v => v.id === o.id));
      this.pushSyntheticStatusCounts(scoped);
    }
  }

  async onRowSelect(event: any) {
    if (this.mobileQuery.matches) {
      await this.ptableService.openObject(event.data, this.disableRoute);
    }
  }

  async onRowUnSelect(event: any) {
    if (!this.mobileQuery.matches && this.selectedRows.length === 0) {
      await this.ptableService.openObject(event.data, this.disableRoute);
    }
  }

  async onPageChange(event: any) {
    await this.ptableService.onPageChange(event.rows, event.first);
  }

  toggleStatusFilter(name: string) {
    const newTableFilter = {...this.tableFilters};
    let newValue = newTableFilter.statusSearchString?.value ?? null;
    if (newValue?.includes(name)) {
      const index = newValue.indexOf(name);
      newValue.splice(index, 1);
      if (newValue.length === 0) {
        newValue = null;
      }
    } else {
      if (newValue === null) {
        newValue = [name];
      } else {
        newValue.push(name);
      }
    }
    if (!newTableFilter.statusSearchString) {
      newTableFilter.statusSearchString = {value: null, matchMode: 'in'};
    }
    newTableFilter.statusSearchString.value = newValue;
    if (newValue !== null) {
      newTableFilter.statusSearchString.operator = 'and';
    } else {
      delete newTableFilter.statusSearchString.operator;
    }
    this.dt.filter(newValue, 'statusSearchString', 'in');
    this.tableFilters = newTableFilter;
    this.dt.filters = newTableFilter;
  }

  async createMultipleChecklists() {

    this.sharedservice.isLoading.next([
      true,
      'Vennligst vent...',
      [
        `Oppretter ${this.selectedRows.length} sjekklister...`
      ],
    ]);

    for (const object of this.selectedRows) {
      await this.checklistservice.create(object, false, this.projectid, false);
    }

    this.sharedservice.isLoading.next([false, '', [], []]);
    this.selectedRows = [];
  }

  async deleteMultipleObjects() {

    const sheet = this.bottomSheet.open(ConfirmComponent, {
      backdropClass: 'blur-dialog-backdrop',
      data: {
        title: `Slette objekter?`,
        text: `${this.selectedRows.length} objekter vil bli slettet.`,
        multiLine: ['Sjekklister tilhørende objektene vil også bli slettet.'],
        list: this.selectedRows.map((checklist) => checklist.name),
        yes: {
          name: 'Slett',
          icon: 'delete_forever',
        },
        no: {
          name: 'Avbryt',
          icon: 'close',
        },
      },
    });

    sheet
      .afterDismissed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (confirm) => {
        if (confirm) {
          this.sharedservice.isLoading.next([
            true,
            'Vennligst vent...',
            [
              `Sletter ${this.selectedRows.length} objekter og tilhørende sjekklister...`
            ],
          ]);

          for (const object of this.selectedRows) {
            await this.objectservice.deleteObject(object);
          }

          this.sharedservice.isLoading.next([false, '', [], []]);
          this.snackbarservice.openSnackBar(
            `${this.selectedRows.length} objekter og tilhørende sjekklister ble slettet.`,
            ''
          );
          this.selectedRows = [];
        }
      });
  }

  isTableFiltered(): boolean {
    return Object.values(this.tableFilters).some(filter => filter?.value && filter.value.length > 0);
  }

  private async callSetTableSortAndFilterFromQueryParams() {
    const result = this.ptableService.setTableSortAndFilterFromQueryParams(
      this.tableSort,
      this.sortButtons,
      this.tableFilters,
      this.tableFiltersReady
    );
    if (!this.tableFiltersReady) {
      setTimeout(async () => {
        this.tableFiltersReady = true;
        await this.callSetTableSortAndFilterFromQueryParams();
        const tablePages = await this.ptableService.getPagesOnLoad();
        // A stored page offset belongs to the unfiltered list. Applying it to a
        // filtered (smaller) result set lands on an out-of-range page => empty table.
        // When a filter is active on restore, start at the first page.
        this.pageIndex = this.numberOfTableFilters > 0 ? 0 : tablePages.pageIndex;
        this.pageSize = tablePages.pageSize;
        this.archivedVisible = tablePages.archivedVisible;
      }, 100);
    } else if (result) {
      this.tableSort = result.tableSort;
      this.sortButtons = result.sortButtons;
      this.tableFilters = result.tableFilters;
      this.numberOfTableFilters = result.numberOfTableFilters;
      this.numberOfTableSorts = result.numberOfTableSorts;
      this.searchString = result.searchString;
    }
  }

}
